export default {
      id: "reefer__mode-usage",
      viewBox: "0 0 24 38",
      url: __webpack_public_path__ + "img/icons.svg#reefer__mode",
      toString: function () {
        return this.url;
      }
    }